import '@tcaster/tcaster-theme/semantic.min.css';
import './index.css';

import React from 'react';
import { render } from 'react-dom';

import App from './App';

render(<App />, document.querySelector('#app'));
